module.exports = __webpack_public_path__ + "img/4.fcd202b7.jpg";